import { 
  useCallback, 
  useContext, 
  useEffect, 
  useState 
} from 'react'
import update from 'immutability-helper'

import { ContextApi } from '../../context/contextApi';
import { DragLineCameras } from './dragLineCameras.jsx'

import styles from './style.module.scss';

const style = {
  width: 400,
  padding: 20,
  backgroundColor: '#2B292A',
  zIndex: 1400
}

export const ContainerCameras = ({ idRegiao }) => {
    const { allCameras, getCameras, ordernarCameras } = useContext(ContextApi)

    useEffect(() => {
      getCameras()
    }, [])

    let filterCamSelectedFromRegion = allCameras.filter(camera => camera.area_regiao.id === idRegiao)

  {
    const [cards, setCards] = useState(filterCamSelectedFromRegion)

    useEffect(() => {
        let ids;
        ids = cards.map(id => id.id)
          const idPosition = {
            ids
          }
            ordernarCameras(idRegiao, idPosition)               
    }, [cards])

    const moveCard = useCallback((dragIndex, hoverIndex) => {
      setCards((prevCards) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex]],
          ],
        }),
      )
    }, [])
    const renderCard = useCallback((card, index) => {
      return (
        <>
            <DragLineCameras
            key={card.id}
            index={index}
            id={card.id}
            text={card.nome_camera}
            moveCard={moveCard}
            idRegiao={idRegiao}
            />
        </>
      )
    }, [])
    return (
      <>
        <span className={styles.titleDragContainer}>Arraste e solte as câmeras na posição desejada</span>
        <div style={style}>{cards.map((card, i) => renderCard(card, i))}</div>
      </>
    )
  }
}
